import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "course" }
const _hoisted_2 = { class: "course-body" }
const _hoisted_3 = { class: "course-doc" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_side_menu = _resolveComponent("side-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.menuData.length)
        ? (_openBlock(), _createBlock(_component_el_menu, {
            key: 0,
            class: "course-side-bar",
            "default-active": _ctx.defaultActiveMenu,
            onSelect: _ctx.handleSelectMenu
          }, {
            default: _withCtx(() => [
              _createVNode(_component_side_menu, { menuData: _ctx.menuData }, null, 8, ["menuData"])
            ]),
            _: 1
          }, 8, ["default-active", "onSelect"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("iframe", {
          src: _ctx.docSrc,
          frameborder: "no",
          border: "0"
        }, null, 8, _hoisted_4)
      ])
    ])
  ]))
}